var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74292 8.32812H21.3808C22.3828 8.32812 23.1862 9.15515 23.1862 10.166V16.6719C21.787 16.433 20.4059 16.7638 19.2865 17.5173H15.9646V21.193H16.9395C16.8402 21.8179 16.8402 22.4335 16.9395 23.0308H8.74292C7.74994 23.0308 6.9375 22.213 6.9375 21.193V10.166C6.9375 9.15515 7.74994 8.32812 8.74292 8.32812ZM8.74292 12.0038V15.6795H14.1592V12.0038H8.74292ZM15.9646 12.0038V15.6795H21.3808V12.0038H15.9646ZM8.74292 17.5173V21.193H14.1592V17.5173H8.74292Z",
    fill: "#2D9E4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3008 18.2656H21.5008V20.7919H18.8008V22.4762H21.5008V25.0025H23.3008V22.4762H26.0008V20.7919H23.3008V18.2656Z",
    fill: "#2D9E4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableCreate);
export default __webpack_public_path__ + "static/media/table-create.cb53b02ba4cd7399989d3fc44ea226de.svg";
export { ForwardRef as ReactComponent };